module.exports = __webpack_public_path__ + "static/media/hands-helping.ee754d23.svg";